import { createSelector } from "@ngrx/store";
import { collectionsFeature } from "./collections-feature";

export const selectByCollectionId = (collectionId: number) => createSelector(
    collectionsFeature.selectEntities,
    (entities) => {
        return entities[collectionId]
    });
